var _path, _path2;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
import { forwardRef } from "react";
const SvgLineSimple = (props, ref) => /*#__PURE__*/React.createElement("svg", _extends({
  xmlns: "http://www.w3.org/2000/svg",
  width: 60,
  height: 60,
  fill: "none",
  viewBox: "0 0 66 66",
  ref: ref
}, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
  stroke: "var(--bg-tertiary, #F2F4F7)",
  strokeLinecap: "round",
  strokeLinejoin: "round",
  strokeWidth: 8,
  d: "M62 33a29 29 0 1 1-58 0 29 29 0 0 1 58 0"
})), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
  stroke: "var(--fg-brand-primary, currentColor)",
  strokeLinecap: "round",
  strokeLinejoin: "round",
  strokeWidth: 8,
  d: "M33 4a29 29 0 0 1 29 29"
})));
const ForwardRef = /*#__PURE__*/forwardRef(SvgLineSimple);
export { ForwardRef as ReactComponent };
export default __webpack_public_path__ + "static/media/line-simple.dcbe64a37f29c2dd77f10e6b2e48fd1c.svg";